<template>
  <!-- <v-app :style="{ background: $vuetify.theme.themes.light.background }"> -->
  <v-app>
    <v-main>
      <router-view/>
      <LineRelinkPopup />
    </v-main>
  </v-app>
</template>

<script>
import LineRelinkPopup from '@/components/common/LineRelinkPopup.vue'

export default {
  name: 'App',
  components: {
    LineRelinkPopup
  },
  data: () => ({
    //
  })
}
</script>
